module.exports = __webpack_public_path__ + "img/logo.45678c15.png";